/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from "react";
import "./footer.scss";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useApi } from "../../../hooks/useApi";

const Footer = () => {
  const [value, setValue] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    if (value === "") {
      toast.error("Lütfen tüm alanları doldurunuz", {
        position: "top-center",
      });
      return false;
    }
    const formData = new FormData();
    formData.append("email", value);
    useApi()
      .post("website/newsletter", formData)
      .then((res) => {
        if (res.data.status) {
          toast.success("Aboneliğiniz başarıyla alınmıştır.", {
            position: "top-center",
          });
          setValue("");
        } else {
          toast.error("Aboneliğiniz şu anda alınamıyor, lütfen daha sonra tekrar deneyiniz.", {
            position: "top-center",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Lütfen daha sonra tekrar deneyiniz.", {
          position: "top-center",
        });
      });
  };
  return (
    <Container>
      <footer>
        <Link to={"/"}>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="205"
              height="46"
              viewBox="0 0 205 46"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M97.9394 0.731445C98.2156 0.731445 98.4394 0.955303 98.4394 1.23145V32.8014C98.4394 33.0775 98.2156 33.3014 97.9394 33.3014H94.6913C94.4152 33.3014 94.1913 33.0775 94.1913 32.8014V32.1575C94.1913 31.6954 93.5932 31.4593 93.2375 31.7542C91.8114 32.9367 89.9589 33.6555 87.8189 33.6555C82.3317 33.6555 77.9062 29.0533 77.9062 23.389C77.9062 17.7248 82.3314 13.1226 87.8189 13.1226C89.9589 13.1226 91.8114 13.8413 93.2375 15.0238C93.5932 15.3188 94.1913 15.0827 94.1913 14.6205V1.23145C94.1913 0.955303 94.4152 0.731445 94.6913 0.731445H97.9394ZM94.191 23.3887C94.191 19.8926 91.5802 17.0162 88.1726 17.0162C84.7651 17.0162 82.1543 19.8926 82.1543 23.3887C82.1543 26.8848 84.7651 29.7612 88.1726 29.7612C91.5802 29.7612 94.191 26.8848 94.191 23.3887ZM70.0204 27.8488C70.2426 27.6476 70.5914 27.6675 70.7766 27.9032L72.5915 30.2129C72.7465 30.4102 72.7323 30.6927 72.5495 30.8646C70.7164 32.5881 68.2349 33.6551 65.5164 33.6551C59.8522 33.6551 55.25 29.0529 55.25 23.3887C55.25 17.7245 59.8522 13.1222 65.5164 13.1222C69.8145 13.1222 73.069 15.6687 74.2663 19.7481C74.3294 19.9634 74.2329 20.1918 74.0388 20.3042L61.7052 27.4469C61.4481 27.5958 61.3764 27.9363 61.5851 28.1478C62.5107 29.0857 64.0472 29.7612 65.5164 29.7612C67.3749 29.7612 68.8448 28.9133 70.0204 27.8488ZM59.4978 23.3887C59.4978 23.7526 59.5346 24.0796 59.5748 24.4371C59.5802 24.4853 59.6333 24.5121 59.6753 24.4879L68.9216 19.1568C69.1815 19.007 69.2539 18.6614 69.0497 18.4416C68.3606 17.6996 67.2954 17.0162 65.5161 17.0162C62.2415 17.0162 59.4978 20.1141 59.4978 23.3887ZM104.957 13.4759C104.681 13.4759 104.457 13.6998 104.457 13.9759V23.9194C104.457 30.2034 107.289 33.655 112.334 33.655C114.167 33.655 115.611 33.0627 116.603 32.3073C117.008 31.9994 117.91 32.3077 117.91 32.8159C117.91 33.0837 118.127 33.3009 118.395 33.3009H121.658C121.934 33.3009 122.158 33.077 122.158 32.8009V13.9756C122.158 13.6994 121.934 13.4756 121.658 13.4756H118.41C118.133 13.4756 117.91 13.6994 117.91 13.9756V23.3882C117.91 27.3711 115.697 29.7607 113.13 29.7607C109.856 29.7607 108.705 27.6811 108.705 24.2735V13.9759C108.705 13.6998 108.481 13.4759 108.205 13.4759H104.957ZM126.737 14.1874C126.583 13.8559 126.825 13.4764 127.191 13.4764H130.686C130.882 13.4764 131.061 13.5915 131.141 13.7706L135.509 23.442C135.686 23.8343 136.243 23.8343 136.421 23.442L140.788 13.7706C140.869 13.5915 141.048 13.4764 141.244 13.4764H144.739C145.105 13.4764 145.347 13.8559 145.192 14.1874L136.418 33.0359C136.239 33.4212 135.691 33.4212 135.512 33.0359L126.737 14.1874ZM164.948 30.8644C165.131 30.6926 165.145 30.41 164.99 30.2127L163.175 27.903C162.99 27.6673 162.641 27.6474 162.419 27.8486C161.243 28.9131 159.773 29.761 157.915 29.761C156.446 29.761 154.909 29.0855 153.984 28.1476C153.775 27.9362 153.846 27.5957 154.104 27.4468L166.437 20.304C166.631 20.1916 166.728 19.9632 166.665 19.748C165.467 15.6685 162.213 13.1221 157.915 13.1221C152.251 13.1221 147.648 17.7243 147.648 23.3885C147.648 29.0527 152.251 33.6549 157.915 33.6549C160.633 33.6549 163.115 32.5879 164.948 30.8644ZM151.974 24.437L151.974 24.4367L151.973 24.4361C151.933 24.0789 151.896 23.7521 151.896 23.3885C151.896 20.1139 154.64 17.016 157.915 17.016C159.694 17.016 160.759 17.6994 161.448 18.4414C161.653 18.6613 161.58 19.0068 161.32 19.1567L152.074 24.4878C152.032 24.512 151.979 24.4852 151.974 24.437ZM181.841 13.1302C182.117 13.1211 182.342 13.3459 182.342 13.6221V17.0209C182.342 17.338 182.051 17.5737 181.736 17.5327C180.833 17.4149 179.846 17.4525 178.802 17.8128C176.058 18.7863 175.262 21.3974 175.262 24.4064V32.8012C175.262 33.0773 175.038 33.3012 174.762 33.3012H171.514C171.237 33.3012 171.014 33.0773 171.014 32.8012V13.9762C171.014 13.7 171.237 13.4762 171.514 13.4762H174.762C175.038 13.4762 175.262 13.7 175.262 13.9762V14.727C175.262 15.2404 176.036 15.4768 176.402 15.1169C177.64 13.8993 179.387 13.2115 181.841 13.1302ZM192.315 43.9224C192.519 43.9224 192.702 43.799 192.779 43.6103L204.719 14.1645C204.853 13.8357 204.611 13.4766 204.256 13.4766H200.737C200.532 13.4766 200.347 13.6024 200.272 13.7938L195.592 25.7098C195.426 26.1315 194.83 26.1332 194.662 25.7125L189.902 13.7911C189.826 13.6012 189.642 13.4766 189.437 13.4766H185.924C185.567 13.4766 185.325 13.8397 185.463 14.169L192.883 31.9605C192.933 32.0827 192.934 32.2201 192.884 32.3426L188.421 43.2328C188.286 43.5618 188.528 43.9224 188.884 43.9224H192.315Z"
                fill="#514A5C"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.8296 45.0533C33.8862 45.0533 43.6597 35.2798 43.6597 23.2237C43.6597 11.1671 33.8857 1.39355 21.8296 1.39355C9.7735 1.39355 0 11.1671 0 23.2237C0 25.0218 0.217258 26.769 0.627141 28.4406C1.0695 30.2447 3.14741 30.9345 4.75599 30.0057C6.03811 29.2654 6.58465 27.7236 6.31996 26.267C6.14053 25.2795 6.0468 24.2624 6.0468 23.2237C6.0468 13.8705 13.6458 6.27148 22.999 6.27148C28.2195 6.27148 32.5077 8.54689 35.1963 12.4308C37.1937 15.3147 35.5136 19.0318 32.4779 20.7899L20.0131 28.009C17.8218 29.2779 17.3466 32.2083 19.7121 33.1122C20.7598 33.5125 21.891 33.7452 22.999 33.7452C25.0149 33.7452 26.754 33.1408 28.2605 32.2277C29.9248 31.2189 32.1676 31.2925 33.37 32.8228C34.3763 34.1035 34.2951 35.9618 32.979 36.9214C30.1807 38.9614 26.7248 40.1754 22.999 40.1754C18.5769 40.1754 14.5467 38.4768 11.5266 35.6972C10.4742 34.7286 8.91654 34.4154 7.67794 35.1304C6.13694 36.0201 5.74301 38.0865 7.05238 39.2913C10.9403 42.8688 16.1299 45.0533 21.8296 45.0533ZM13.2087 25.123L16.7357 23.0892L29.4295 15.7698L29.4245 15.7632C28.3284 14.3036 26.5015 12.7012 22.9998 12.7012C17.5924 12.7012 13.0625 17.8157 13.0625 23.2232C13.0625 23.824 13.1233 24.364 13.1898 24.9544C13.196 25.0101 13.2024 25.0663 13.2087 25.123Z"
                fill="#514A5C"
              />
            </svg>
          </span>
        </Link>
        <div className="footer-menu d-flex flex-lg-row flex-column justify-content-lg-between">
          <div>
            <h6>Site</h6>
            <ul className="menu-list">
              <li>
                <Link to={"/edutest"} className="footer-link">
                  Edutest nedir?
                </Link>
              </li>
              <li>
                <Link to={"/profile"} className="footer-link">
                  Hesabım
                </Link>
              </li>
              <li>
                <Link to={"/about"} className="footer-link">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to={"/contact"} className="footer-link">
                  Bize Ulaşın
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-4 col-12">
            <div className="email-subs d-flex flex-column  w-100">
              <h6 className="text-lg-end">
                Seni gelişmelerden haberdar edelim
              </h6>
              <form
                onSubmit={handleSubmit}
                className="email-area position-relative"
              >
                <input
                  type="email"
                  className="email-input"
                  placeholder="Mail adresin"
                  value={value}
                  onChange={(e) => setValue(e.target.value) }
                />
                <button className="email-button">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="31"
                    height="25"
                    viewBox="0 0 31 25"
                    fill="none"
                  >
                    <path
                      d="M5.16797 12.0527H25.8346M25.8346 12.0527L18.0846 6.05273M25.8346 12.0527L18.0846 18.0527"
                      stroke="#3C3744"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </form>
              <p className="email-info text-lg-end ">
                Hemen abone ol ve Eduvery’nin fırsatlarını kaçırma. Seni tüm
                gelişmelerden haberdar edeceğiz.
              </p>
            </div>
          </div>
        </div>
        <div className="footer-sub-menu d-flex flex-lg-row flex-column justify-content-between">
          <div className="d-flex gap-4 mb-lg-0 flex-lg-row flex-column">
            <Link to={"gizlilik-veri-politikasi"} className="footer-sub-link">
              Gizlilik ve Güvenlik
            </Link>
            <Link to={"kullanim-kosullari"} className="footer-sub-link">
              Kullanıcı Koşulları
            </Link>
            <a href="./files/eduvery-kvkk-sozlesmesi.pdf" target="_blank" className="footer-sub-link">
              KVKK Aydınlatma Metni
            </a>
          </div>
          <p className="mt-lg-0 mt-3">Tüm Hakları Saklıdır. <a href="https://dveb.com.tr/" target="_blank" className="text-white">DveB</a></p>
        </div>
      </footer>
    </Container>
  );
};

export default Footer;
